import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=15cb562e&scoped=true&"
import script from "./DownloadPage.vue?vue&type=script&lang=js&"
export * from "./DownloadPage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPage.vue?vue&type=style&index=0&id=15cb562e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb562e",
  null
  
)

export default component.exports